import React from "react";
import { AlertTriangle, History, Users, Heart, Plus } from "lucide-react";

interface MedicalHistory {
  id: string;
  category: string;
  items: {
    id: string;
    name: string;
    date?: string;
    status: string;
  }[];
}

const mockMedicalHistory: MedicalHistory[] = [
  {
    id: "1",
    category: "Past Illnesses",
    items: [
      { id: "1-1", name: "Hypertension", date: "2018", status: "Resolved" },
      { id: "1-2", name: "Type 2 Diabetes", date: "2019", status: "Active" },
    ],
  },
  {
    id: "2",
    category: "Surgeries",
    items: [
      { id: "2-1", name: "Appendectomy", date: "2015", status: "Completed" },
      {
        id: "2-2",
        name: "Cataract Surgery",
        date: "2020",
        status: "Completed",
      },
    ],
  },
  {
    id: "3",
    category: "Allergies",
    items: [
      { id: "3-1", name: "Penicillin", status: "Active" },
      { id: "3-2", name: "Peanuts", status: "Active" },
    ],
  },
  {
    id: "4",
    category: "Family History",
    items: [
      { id: "4-1", name: "Heart Disease (Father)", status: "Noted" },
      { id: "4-2", name: "Diabetes (Mother)", status: "Noted" },
    ],
  },
];

export const MedicalHistoryTab: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-lg font-medium dark:text-white">Medical History</h2>
        <button className="inline-flex items-center px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary/90">
          <Plus className="h-4 w-4 mr-2" />
          Add History
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {mockMedicalHistory.map((category) => (
          <div
            key={category.id}
            className="bg-white dark:bg-darkCardBackground rounded-lg border border-gray-200 dark:border-gray-700 p-4"
          >
            <div className="flex items-center space-x-2 mb-4">
              {category.category === "Allergies" && (
                <AlertTriangle className="w-5 h-5 text-red-500" />
              )}
              {category.category === "Family History" && (
                <Users className="w-5 h-5 text-primary" />
              )}
              {category.category === "Past Illnesses" && (
                <Heart className="w-5 h-5 text-primary" />
              )}
              {category.category === "Surgeries" && (
                <History className="w-5 h-5 text-primary" />
              )}
              <h3 className="font-medium text-gray-900 dark:text-white">
                {category.category}
              </h3>
            </div>
            <div className="space-y-3">
              {category.items.map((item) => (
                <div
                  key={item.id}
                  className="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-800 rounded-md"
                >
                  <div>
                    <p className="font-medium text-gray-900 dark:text-white">
                      {item.name}
                    </p>
                    {item.date && (
                      <p className="text-sm text-gray-500 dark:text-gray-400">
                        {item.date}
                      </p>
                    )}
                  </div>
                  <span
                    className={`px-2 py-1 text-xs font-medium rounded-full ${
                      item.status === "Active"
                        ? "bg-red-100 text-red-700"
                        : item.status === "Resolved"
                          ? "bg-green-100 text-green-700"
                          : "bg-gray-100 text-gray-700"
                    }`}
                  >
                    {item.status}
                  </span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
